// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    Kayak,
    Key,
    KeyRound,
    KeySquare,
    Keyboard,
    KeyboardMusic,
    KeyboardOff,
    Lamp,
    LampCeiling,
    LampDesk,
    LampFloor,
    LampWallDown,
    LampWallUp,
    LandPlot,
    Landmark,
    Languages,
    Laptop,
    LaptopMinimal,
    LaptopMinimalCheck,
    Lasso,
    LassoSelect,
    LayerArrowDown,
    LayerArrowUp,
    Layers,
    Layers2,
    LayersArrowDown,
    LayersArrowUp,
    LayersMinus,
    LayersPlus,
    LayoutDashboard,
    LayoutFreeform,
    LayoutGrid,
    LayoutList,
    LayoutPanelLeft,
    LayoutPanelTop,
    LayoutTemplate,
    Leaf,
    LeafyGreen,
    Lectern,
    LensConcave,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "kayak" through "lens-concave", inclusive. */
const shard: Record<string, LucideIcon> = {
    kayak: Kayak,
    key: Key,
    "key-round": KeyRound,
    "key-square": KeySquare,
    keyboard: Keyboard,
    "keyboard-music": KeyboardMusic,
    "keyboard-off": KeyboardOff,
    lamp: Lamp,
    "lamp-ceiling": LampCeiling,
    "lamp-desk": LampDesk,
    "lamp-floor": LampFloor,
    "lamp-wall-down": LampWallDown,
    "lamp-wall-up": LampWallUp,
    "land-plot": LandPlot,
    landmark: Landmark,
    languages: Languages,
    laptop: Laptop,
    "laptop-minimal": LaptopMinimal,
    "laptop-minimal-check": LaptopMinimalCheck,
    lasso: Lasso,
    "lasso-select": LassoSelect,
    "layer-arrow-down": LayerArrowDown,
    "layer-arrow-up": LayerArrowUp,
    layers: Layers,
    "layers-2": Layers2,
    "layers-arrow-down": LayersArrowDown,
    "layers-arrow-up": LayersArrowUp,
    "layers-minus": LayersMinus,
    "layers-plus": LayersPlus,
    "layout-dashboard": LayoutDashboard,
    "layout-freeform": LayoutFreeform,
    "layout-grid": LayoutGrid,
    "layout-list": LayoutList,
    "layout-panel-left": LayoutPanelLeft,
    "layout-panel-top": LayoutPanelTop,
    "layout-template": LayoutTemplate,
    leaf: Leaf,
    "leafy-green": LeafyGreen,
    lectern: Lectern,
    "lens-concave": LensConcave,
};

export default shard;
